/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import { Link, useParams } from 'react-router-dom';
import NavLinkAdapter from "../../@BASE/core/NavLinkAdapter";
import Button from "@mui/material/Button";
import BASESvgIcon from "../../@BASE/core/BASESvgIcon";
import { selectUser } from "../store/userSlice";
import { useSelector } from "react-redux";
import DeleteModal from "./crud/DeleteModal";
import authRoles from "../auth/authRoles";

function AnswerKeyHeader(props) {
  const routeParams = useParams();
  const user = useSelector(selectUser);

  return (
    <div className="p-24 sm:p-32 w-full print:hidden">
      <div className="flex flex-col items-center sm:items-start">
        <motion.div
          initial={{ x: 20, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
        >
          <Typography
            className="flex items-center"
            component={Link}
            role="button"
            to={props.back}
            color="inherit"
          >
            <BASESvgIcon size={20}>heroicons-outline:arrow-sm-left</BASESvgIcon>
            <span className="flex mx-4 font-medium">{props.back_title}</span>
          </Typography>
        </motion.div>
      </div>
    </div>
  );
}

export default AnswerKeyHeader;
